import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "../../theme/customTheme";

export const useChatStyles = makeStyles({
  chat: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    position: "relative",
  },
  messages: {
    paddingTop: "20px",
    overflowY: "auto",
    flex: 1,
    minHeight: 0,
    position: "relative",
    width: "100%",
    backgroundColor: designTokens.neutral[50],
  },
  messageBar: {
    padding: `${designTokens.spacing[5]} ${designTokens.spacing[5]} ${designTokens.spacing[5]} ${designTokens.spacing[5]}`,
    backgroundColor: designTokens.neutral[50],
    flexWrap: "nowrap",
  },
  messageBarMobile: {
    padding: `${designTokens.spacing[5]} ${designTokens.spacing[3]} ${designTokens.spacing[3]} ${designTokens.spacing[3]}`,
    backgroundColor: designTokens.neutral[50],
    flexWrap: "nowrap",
  },
  loadingOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    zIndex: 9999,
    gap: "16px",
  },
  loadingText: {
    fontSize: "16px",
    fontWeight: 600,
    color: designTokens.neutral[900],
  },
});
